import { LOGIN_SUCCESS } from "./actionTypes";

const initialState = {
  loading: false,
  token: "",
  userId: "",
  userRole: "",
  user: null,
  email: null,
  access : []
};

export const loginReducer = (store = initialState, { type, payload }) => {
  switch (type) {
    case LOGIN_SUCCESS:
      return {
        ...store,
        loading: false,
        token: payload.token,
        user: { ...payload.user },
        userId: payload.userId,
        userRole: payload.userRole,
        email: payload.email,
        access: payload.access
      };

    default:
      return store; // ✅ Always return current state for unknown actions
  }
};
